import classNames from "classnames";
import { logLevelLocale } from "Common/dictionaries/logLevel";
import React from "react";
import styles from "./logItem.module.css";
import { ChipStatus } from "UiKit";
const chipType = {
    1: "primary",
    2: "info",
    3: "warning",
    4: "error"
};
export default function LogItem({ item }) {
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles["info-container"] },
            React.createElement("span", { className: styles.date }, item.DateTime),
            React.createElement("div", { className: styles["type-container"] },
                React.createElement(ChipStatus, { styleType: chipType[item.LogLevel], size: "34" }, logLevelLocale[item.LogLevel]))),
        React.createElement("span", { className: classNames(styles.message, "pre-wrap break-word") }, item.Message)));
}
